import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IInitializeUserNlpOnboardingStageParams {
  nlpOnboardingStage: string;
}

export class InitializeUserNlpOnboardingStageRequest extends Request<IInitializeUserNlpOnboardingStageParams, IResult> {
  constructor(params: IInitializeUserNlpOnboardingStageParams) {
    super('updateUserNlpOnboardingStage', params);
  }
}
